const initialState = {
  color: '#216BB4',
  text: 'Initial toast state',
  visible: false,
  delay: 5000,
};

const toast = (state = initialState, action) => {
  switch (action.type) {
    case 'TOAST_SHOW':
      return { ...state, ...action.payload, visible: true };
    case 'TOAST_HIDE':
      return { ...state, visible: false };
    default:
      return state;
  }
};

export { toast };



// WEBPACK FOOTER //
// ./src/view/common/Toast/reducer.js